import React, { useState } from 'react';
import PurchaseOrdersTab from './PurchaseOrdersTab';
import GatePassTab from './GatePassTab';
import BillsTab from './BillsTab';

const SUB_TABS = [
  { id: 'orders', label: '📋 Purchase Orders' },
  { id: 'inward', label: '↓ Inward (GRN)' },
  { id: 'bills', label: '🧾 Bills' },
];

const PurchasesTab = () => {
  const [active, setActive] = useState('orders');

  return (
    <div>
      {/* Sub-tab bar */}
      <div style={styles.subTabBar}>
        {SUB_TABS.map((t) => (
          <button
            key={t.id}
            onClick={() => setActive(t.id)}
            style={{ ...styles.subTab, ...(active === t.id ? styles.subTabActive : {}) }}
          >
            {t.label}
          </button>
        ))}
      </div>

      {/* Active sub-tab content */}
      <div>
        {active === 'orders' && <PurchaseOrdersTab />}
        {active === 'inward' && <GatePassTab lockDirection="inward" />}
        {active === 'bills' && <BillsTab />}
      </div>
    </div>
  );
};

const styles = {
  subTabBar: {
    display: 'flex',
    gap: '4px',
    padding: '0 30px',
    borderBottom: '2px solid #f0f0f0',
    background: '#faf7fc',
  },
  subTab: {
    padding: '14px 22px',
    background: 'transparent',
    border: 'none',
    borderBottom: '3px solid transparent',
    marginBottom: '-2px',
    cursor: 'pointer',
    fontSize: '14px',
    fontWeight: 600,
    color: '#7f8c8d',
  },
  subTabActive: {
    color: '#8e44ad',
    borderBottom: '3px solid #8e44ad',
  },
};

export default PurchasesTab;